export function getMembershipLabel(membershipKind) {
	const label =
		membershipKind === 'admin'
			? 'an Admin'
			: membershipKind === 'moderator'
			? 'a Moderator'
			: membershipKind === 'member'
			? 'a Member'
			: membershipKind === 'follower'
			? 'a Follower'
			: membershipKind === 'observer'
			? 'an Observer'
			: undefined;
	return label && `You are ${label}`;
}
